import { IHoverEntry } from './day-entry-info-drag-row.interfaces';

export const hoverEntry = ({ entry, currentElem, ref, monitor }: IHoverEntry) => {
  if (!ref.current) return;

  const dragIndex = currentElem.source._id;
  const hoverIndex = entry.source._id;

  if (dragIndex === hoverIndex) return;

  const hoverBoundingRect = ref.current.getBoundingClientRect();

  const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

  const clientOffset = monitor.getClientOffset();

  const hoverClientY = clientOffset.y - hoverBoundingRect.top;

  if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) return;
  if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) return;

  return { dragIndex, hoverIndex };
};
